import { render, staticRenderFns } from "./AdminNewBoard.vue?vue&type=template&id=32a4bc7e&scoped=true&"
import script from "./AdminNewBoard.vue?vue&type=script&lang=js&"
export * from "./AdminNewBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a4bc7e",
  null
  
)

export default component.exports